module.exports = __webpack_public_path__ + "static/media/ios-options.21a6d93e.svg";